import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle, ShieldAlert } from 'lucide-react';

const ResponsibleDisclosure = () => {
    return (
        <div className="landing-page">
            <main className="policy-content" style={{ paddingTop: '120px', paddingBottom: '100px', maxWidth: '800px', margin: '0 auto', paddingLeft: '7.6923%', paddingRight: '7.6923%' }}>
                <Link to="/" className="back-link" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '40px' }}>
                    <ArrowLeft size={20} />
                    Back to Home
                </Link>

                <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '40px' }}>Responsible Disclosure</h1>

                <div className="policy-text" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                    <p className="section-description" style={{ textAlign: 'left', margin: '0 0 30px 0' }}>
                        At Adjactive, we believe that security is a collaborative effort. We value the work of security researchers and appreciate reports of potential vulnerabilities in our systems or systems we audit.
                    </p>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>Reporting Guidelines</h2>
                    <p style={{ marginBottom: '20px' }}>
                        If you believe you have found a security vulnerability, please submit your report to us at <a href="mailto:tech@adjactive.com" style={{ color: 'var(--brand-primary)' }}>tech@adjactive.com</a>. A well-written report should include:
                    </p>
                    <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
                        <li>Description of the vulnerability and its potential impact.</li>
                        <li>Detailed steps to reproduce the vulnerability (proof-of-concept scripts or screenshots are helpful).</li>
                        <li>The specific URL or component affected.</li>
                    </ul>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>Our Commitment</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px', marginTop: '20px' }}>
                        <div style={{ display: 'flex', gap: '16px', padding: '16px', background: 'rgba(255,255,255,0.03)', borderLeft: '3px solid var(--brand-primary)' }}>
                            <CheckCircle size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                            <p>We will acknowledge receipt of your report within 48 hours.</p>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', padding: '16px', background: 'rgba(255,255,255,0.03)', borderLeft: '3px solid var(--brand-primary)' }}>
                            <CheckCircle size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                            <p>We will work with you to understand and validate the report.</p>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', padding: '16px', background: 'rgba(255,255,255,0.03)', borderLeft: '3px solid var(--brand-primary)' }}>
                            <CheckCircle size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                            <p>We will provide an estimated timeframe for a fix and notify you when the vulnerability is remediated.</p>
                        </div>
                    </div>

                    <h2 style={{ color: 'var(--text-primary)', marginTop: '40px', marginBottom: '20px' }}>Rules of Engagement</h2>
                    <p style={{ marginBottom: '20px' }}>
                        To protect our customers and users, we ask that you:
                    </p>
                    <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
                        <li>Avoid privacy violations, destruction of data, and interruption or degradation of our services.</li>
                        <li>Only interact with accounts you own or with explicit permission from the account holder.</li>
                        <li>Give us a reasonable amount of time to resolve the issue before making it public.</li>
                    </ul>

                    <div style={{ marginTop: '60px', padding: '30px', background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)', textAlign: 'center' }}>
                        <ShieldAlert size={48} style={{ color: 'var(--brand-primary)', marginBottom: '20px' }} />
                        <h3>Thank you for helping keep Adjactive secure.</h3>
                        <p style={{ marginTop: '10px' }}>Questions? Reach out at <a href="mailto:tech@adjactive.com" style={{ color: 'var(--brand-primary)' }}>tech@adjactive.com</a></p>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ResponsibleDisclosure;
